import { NodeDetails } from '../../app/modules/types/scan'
import { apiClient } from '../client'

/**
 * Workflow Nodes API endpoints
 */
export const nodesApi = {
  /**
   * Get node result by ID
   */
  getResult: async (nodeId: string): Promise<NodeDetails> => {
    const { data } = await apiClient.get(`/node/${nodeId}/result/`)
    return data
  },
}
